import { useState, useEffect, useReducer, useContext } from "react";
import api from "../../services/api";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";

const reducer = (state, action) => {
  if (action.type === "LOAD_WHATSAPPS") {
    const whatsApps = action.payload;

    return [...whatsApps];
  }

  if (action.type === "UPDATE_WHATSAPPS") {
    const whatsApp = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      state[whatsAppIndex] = whatsApp;
      return [...state];
    } else {
      return [whatsApp, ...state];
    }
  }

  if (action.type === "UPDATE_SESSION") {
    const whatsApp = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      state[whatsAppIndex].status = whatsApp.status;
      state[whatsAppIndex].updatedAt = whatsApp.updatedAt;
      state[whatsAppIndex].qrcode = whatsApp.qrcode;
      state[whatsAppIndex].retries = whatsApp.retries;
      return [...state];
    } else {
      return [...state];
    }
  }

  if (action.type === "UPDATE_WHATSAPPS_COEXISTENCE") {
    const { id, businessAppStatus, wabaOffboardedAt } = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === id);

    if (whatsAppIndex !== -1) {
      // Substitui o item por uma cópia (imutável) em vez de mutar in place:
      // um componente memoizado pela referência do item não re-renderizaria
      // a badge no offboarding se o objeto fosse mutado.
      const newState = [...state];
      newState[whatsAppIndex] = {
        ...newState[whatsAppIndex],
        businessAppStatus,
        wabaOffboardedAt
      };
      return newState;
    }
    return state;
  }

  if (action.type === "DELETE_WHATSAPPS") {
    const whatsAppId = action.payload;

    const whatsAppIndex = state.findIndex((s) => s.id === whatsAppId);
    if (whatsAppIndex !== -1) {
      state.splice(whatsAppIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useWhatsApps = () => {
  const [whatsApps, dispatch] = useReducer(reducer, []);
  const [loading, setLoading] = useState(true);
//   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);



  useEffect(() => {
    setLoading(true);
    let isMounted = true;

    const fetchSession = async () => {
      try {
        const { data } = await api.get("/whatsapp/?session=0");
        
        if (isMounted) {
          dispatch({ type: "LOAD_WHATSAPPS", payload: data });
          setLoading(false);
        }
      } catch (_) {
        if (isMounted) {
          setLoading(false);
        }
        // toastError(err);
      }
    };
    
    fetchSession();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!user?.companyId || !socket) {
      return;
    }

    const companyId = user.companyId;
//    const socket = socketManager.GetSocket();

    const onCompanyWhatsapp = (data) => {
      if (data.action === "update") {
        dispatch({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
      }
      if (data.action === "delete") {
        dispatch({ type: "DELETE_WHATSAPPS", payload: data.whatsappId });
      }
    }

    const onCompanyWhatsappSession = (data) => {
      if (data.action === "update") {
        dispatch({ type: "UPDATE_SESSION", payload: data.session });
      }
    }

    const onCompanyWabaStatus = (data) => {
      if (!data?.whatsappId) return;

      // Só os eventos de ciclo de vida de coexistência mexem nesses campos.
      // Os demais (quality, review status) chegam pelo canal de whatsapp.
      if (
        data.action === "account_offboarded" ||
        data.action === "account_reconnected"
      ) {
        dispatch({
          type: "UPDATE_WHATSAPPS_COEXISTENCE",
          payload: {
            id: data.whatsappId,
            businessAppStatus: data.businessAppStatus,
            wabaOffboardedAt: data.wabaOffboardedAt
          }
        });
      }
    };

    socket.on(`company-${companyId}-whatsapp`, onCompanyWhatsapp);
    socket.on(`company-${companyId}-whatsappSession`, onCompanyWhatsappSession);
    socket.on(`company-${companyId}-waba-status`, onCompanyWabaStatus);

    return () => {
      socket.off(`company-${companyId}-whatsapp`, onCompanyWhatsapp);
      socket.off(`company-${companyId}-whatsappSession`, onCompanyWhatsappSession);
      socket.off(`company-${companyId}-waba-status`, onCompanyWabaStatus);
    };
  }, [socket, user?.companyId]);

  return { whatsApps, loading };
};

export default useWhatsApps;
